// extracted by mini-css-extract-plugin
export default {"button":"button_button__Eky5u","primary":"button_primary__ez-wX","secondary":"button_secondary__az2ig","danger":"button_danger__35X1D"};